module.exports = __webpack_public_path__ + "static/media/logo-onboarding.b1bf0bfc.png";